module.exports = __webpack_public_path__ + "img/1566020557.e0499e2f.jpg";